// ResponsiveProductionUnits.jsx — bascule desktop / mobile pour "Unités de production"
// À copier dans : src/GestionProductions/ResponsiveProductionUnits.jsx
//   <Route path="/production/units" element={<ResponsiveProductionUnits />} />
import React from "react";
import ProductionList from "./ProductionList";
import ProductionUnitsMobile from "./ProductionUnitsMobile";
import useIsMobile from "../hooks/useIsMobile";

export default function ResponsiveProductionUnits(props) {
  return useIsMobile() ? <ProductionUnitsMobile {...props} /> : <ProductionList {...props} />;
}
